import { useState, useEffect, useMemo } from 'react';
import BroadcastCard from './BroadcastCard';
import { ShimmerBroadcastCard } from '../Shimmers/ShimmerBroadcastCard';

const FILTER_KEY = 'prae_filters';
const ALL_STATUS = [
  { value: 'active', label: 'En cours' },
  { value: 'new', label: 'Nouveaux' },
  { value: 'paused', label: 'En pause' },
  { value: 'completed', label: 'Terminés' },
  { value: 'deleted', label: 'Supprimés' },
];

function BroadcastList({
  broadcasts,
  selectedBroadcastId,
  onSelectBroadcast,
  onEditBroadcast,
  onScheduleChange,
  onDuplicateBroadcast,
  onDelete,
  onPause,
  onResume,
  loadingCardId,
}) {
  const [selectedStatus, setSelectedStatus] = useState(() => {
    try {
      const saved = localStorage.getItem(FILTER_KEY);
      return saved ? JSON.parse(saved) : ['active', 'new', 'paused'];
    } catch {
      return ['active', 'new', 'paused'];
    }
  });

  useEffect(() => {
    localStorage.setItem(FILTER_KEY, JSON.stringify(selectedStatus));
  }, [selectedStatus]);

  const filteredBroadcasts = useMemo(
    () =>
      broadcasts
        ? broadcasts.filter(b => selectedStatus.includes(b.status))
        : [],
    [broadcasts, selectedStatus]
  );

  const handleToggleStatus = status => {
    setSelectedStatus(prev =>
      prev.includes(status) ? prev.filter(s => s !== status) : [...prev, status]
    );
  };

  if (!broadcasts) return <ShimmerBroadcastCard count={3} />;

  return (
    <div>
      <div className="flex flex-wrap gap-3 mb-4">
        {ALL_STATUS.map(s => (
          <label
            key={s.value}
            className={`flex items-center gap-2 cursor-pointer px-3 py-1 rounded-full border 
              ${
                selectedStatus.includes(s.value)
                  ? 'bg-blue-600 text-white border-blue-700'
                  : 'bg-gray-100 text-gray-700 border-gray-300'
              }
            `}
            style={{ fontSize: '0.97em' }}
          >
            <input
              type="checkbox"
              checked={selectedStatus.includes(s.value)}
              onChange={() => handleToggleStatus(s.value)}
              className="accent-blue-600"
            />
            {s.label}
          </label>
        ))}
      </div>

      <div className="space-y-4">
        {filteredBroadcasts.length === 0 && (
          <div className="text-gray-400 text-center p-6">
            Aucun broadcast pour ce filtre.
          </div>
        )}
        {filteredBroadcasts.map(broadcast => (
          <div
            key={broadcast.id}
            onClick={() => onSelectBroadcast(broadcast.id)}
            className={`p-4 border rounded cursor-pointer transition ${
              broadcast.id === selectedBroadcastId
                ? 'bg-blue-100 border-blue-500'
                : 'bg-white border-gray-300'
            }`}
          >
            <BroadcastCard
              broadcast={broadcast} // Passer l'objet complet
              broadcastName={broadcast.name}
              description={broadcast.description}
              smtpProviderName={broadcast.smtpProviderName}
              currentDay={broadcast.current_day}
              totalDays={broadcast.warmup_total_days}
              status={broadcast.status}
              scheduledDate={broadcast.scheduled_start_at}
              isLoading={loadingCardId === broadcast.id}
              onEdit={() => onEditBroadcast(broadcast)}
              onDuplicate={() => onDuplicateBroadcast(broadcast)} // NOUVEAU
              onScheduleChange={
                onScheduleChange
                  ? dateStr => onScheduleChange(broadcast.id, dateStr)
                  : undefined
              }
              onDelete={onDelete ? () => onDelete(broadcast.id) : undefined}
              onPause={onPause ? () => onPause(broadcast.id) : undefined}
              onResume={onResume ? () => onResume(broadcast.id) : undefined}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default BroadcastList;
